import axios from "axios";
import { baseUrl } from "../Common/Constants";
import { Device } from "../Common/Types/types";
import httpClient from "../Core/http";

class DeviceAPi {
    getDevices(): Promise<any> {
        let url = baseUrl + "device";
        return axios.get<Device[]>(url).then((response) => {
        return response.data;
        });
    }
    getBlacklist(): Promise<any> {
        let url = baseUrl + "device/blacklist";
        return axios.get<string[]>(url).then((response) => {
           return response.data;
        });
    }
    editBlacklist(editedBlacklist:string): Promise<any> {
        let url = baseUrl + "device/updateblacklist";
        return axios.get<string[]>(url, { params: { cadids: editedBlacklist, queryType: "0" } }).then((response) => {
            return response.data;
        });
    }
}

export const DeviceApi = new DeviceAPi();
